import type { Assignment } from '../shared/queries/roles';
import { assignmentTypes } from '../shared/authorization/assignmentTypes';
import { userRoles } from '../shared/authorization';
import { UserExpirationDate } from './types';

export const getAssignmentKey = (assignment: Assignment) =>
  assignment.assignmentType === assignmentTypes.USER
    ? assignment.assignmentType
    : `${assignment.assignmentType}-${assignment.assignmentCode}`;

export const canUserEditRole = (loggedInUserRole: string, roleToEdit: string) => {
  if (loggedInUserRole === userRoles.SUPER_USER) {
    return true;
  }
  if (!roleToEdit) {
    return true;
  }
  if (loggedInUserRole === userRoles.POWER_USER) {
    return ![userRoles.SUPER_USER].includes(roleToEdit);
  }
  return ![userRoles.SUPER_USER, userRoles.POWER_USER].includes(roleToEdit);
};

export const isInternalEmailAddress = (email: string) => {
  if (!email) {
    return false;
  }
  const lowerEmail = email.toLowerCase();
  const pwcDomainPattern = /@[a-z0-9.-]*\.?pwc\.[a-z]{2,}$/i;
  return pwcDomainPattern.test(lowerEmail) || lowerEmail.endsWith('@pwc.com');
};

export const setDefaultExpirationDate = (expiration: UserExpirationDate[], selectedClientId: number) => {
  const currentValue = expiration.find(({ clientId }) => clientId === selectedClientId);
  return !currentValue?.expirationDate;
};

export const filterUsers = (email: string, users: any[]) => {
  const isInternalUser = isInternalEmailAddress(email);
  if (!isInternalUser) {
    const regex = /@(pwc\.com|\.pwc\.com)$/;
    const NoInternalUsers = users.filter(user => !regex.test(user.email));
    return NoInternalUsers;
  } else {
    return users;
  }
};
